import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getOfferCardTitle} from "../../offer/utils/get_offer_card_headings";
import {ViewType} from "../../view_type/ViewType";
import {
    AmplitudeOfferListingTileEntryPoint,
    AmplitudeOfferTileLocation,
    IAmplitudeOfferListingTileContext
} from "./get_amplitude_offer_select_item_event_properties";
import {getAmplitudeOfferUsp} from "./get_amplitude_offer_usp";

interface IGetAmplitudeOfferTileContextParams {
    displayAddress?: string;
    entryPoint: AmplitudeOfferListingTileEntryPoint;
    isUspVariant: boolean;
    offer: IOfferBoxOffer;
    viewType: ViewType | null;
    /** Screens that share the tile but have no view type of their own name their location here. */
    location?: AmplitudeOfferTileLocation;
}

export const getAmplitudeOfferTileLocation = (viewType: ViewType | null): AmplitudeOfferTileLocation | null => {
    switch (viewType) {
        case ViewType.OFFER_LIST:
        case ViewType.OFFER_LIST_ABROAD:
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
        case ViewType.PROMOTION_LIST:
            return "listing_page";
        case ViewType.OFFER:
            return "investment_page";
        case ViewType.PROPERTY:
            return "property_page";
        default:
            return null;
    }
};

export const getAmplitudeOfferTileContext = ({
    displayAddress,
    entryPoint,
    isUspVariant,
    offer,
    viewType,
    location: locationOverride
}: IGetAmplitudeOfferTileContextParams): IAmplitudeOfferListingTileContext => {
    const location = locationOverride ?? getAmplitudeOfferTileLocation(viewType);
    const isListingTile = location === "listing_page";

    return {
        entryPoint: isUspVariant && isListingTile ? entryPoint : null,
        itemAddress: isUspVariant && isListingTile ? (displayAddress ?? getOfferCardTitle(offer)) : null,
        location,
        usp: isUspVariant ? getAmplitudeOfferUsp(offer) : null
    };
};
import {IOfferBoxOffer} from "../../offer/types/IOfferBoxOffer";
import {getOfferCardTitle} from "../../offer/utils/get_offer_card_headings";
import {ViewType} from "../../view_type/ViewType";
import {
    AmplitudeOfferListingTileEntryPoint,
    AmplitudeOfferTileLocation,
    IAmplitudeOfferListingTileContext
} from "./get_amplitude_offer_select_item_event_properties";
import {getAmplitudeOfferUsp} from "./get_amplitude_offer_usp";

interface IGetAmplitudeOfferTileContextParams {
    displayAddress?: string;
    entryPoint: AmplitudeOfferListingTileEntryPoint;
    isUspVariant: boolean;
    offer: IOfferBoxOffer;
    viewType: ViewType | null;
    /** Screens that share the tile but have no view type of their own name their location here. */
    location?: AmplitudeOfferTileLocation;
}

export const getAmplitudeOfferTileLocation = (viewType: ViewType | null): AmplitudeOfferTileLocation | null => {
    switch (viewType) {
        case ViewType.OFFER_LIST:
        case ViewType.OFFER_LIST_ABROAD:
        case ViewType.OFFER_LIST_MAP:
        case ViewType.OFFER_LIST_MAP_ABROAD:
        case ViewType.PROMOTION_LIST:
            return "listing_page";
        case ViewType.OFFER:
            return "investment_page";
        case ViewType.PROPERTY:
            return "property_page";
        default:
            return null;
    }
};

export const getAmplitudeOfferTileContext = ({
    displayAddress,
    entryPoint,
    isUspVariant,
    offer,
    viewType,
    location: locationOverride
}: IGetAmplitudeOfferTileContextParams): IAmplitudeOfferListingTileContext => {
    const location = locationOverride ?? getAmplitudeOfferTileLocation(viewType);
    const isListingTile = location === "listing_page";

    return {
        entryPoint: isUspVariant && isListingTile ? entryPoint : null,
        itemAddress: isUspVariant && isListingTile ? (displayAddress ?? getOfferCardTitle(offer)) : null,
        location,
        usp: isUspVariant ? getAmplitudeOfferUsp(offer) : null
    };
};
